// extracted by mini-css-extract-plugin
export default {"wrapper":"FolderItem_wrapper__LbZeX","label":"FolderItem_label__QVEiR","checkbox":"FolderItem_checkbox__oynww"};